<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Modificadores de Productos</h3>
      <uv-data-table
        :config="config"
        :data="modificadores"
        :pageRows="15"
        @buttonClick="dtButtonClick"
        @buttonOptClick="optButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Modificador">
      <ModificadoresForm
        :edit="editMode"
        @toggle="toggleModal"
        :key="formIndex"
        :dataEdit="editData"
        @successData="successData"
      ></ModificadoresForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ModificadoresForm from "../Modificadores/ModificadoresForm.vue";
import { mapGetters } from "vuex";

export default {
  name: "ModificadoresCRUD",
  components: {
    modal,
    uvDataTable,
    ModificadoresForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      editData: [],
      config: {
        allowExport: true,
        rawText: "Modificadores",
        selectableRow: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addModificador",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editModificador",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteModificador",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Departamento",
            value: "Departamento",
            canBeFiltered: true,
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addModificador") {
        this.formIndex++;
        this.editMode = false;
        this.showModal = true;
      }
      if (buttonId == "deleteModificador") {
        this.deleteCategoria(idSelected[0]);
      }
      if (buttonId == "editModificador") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.modificadores,
          "Id",
          idSelected[0]
        );
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Modificadores, { id: code });
      if (itemIndex >= 0) {
        return this.Modificadores[itemIndex];
      }

      return false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createModificador(data);
      } else if (doAction == "EDIT") {
        this.editModificador(data);
      }
    },
    createModificador(datos) {
      let dataSend = this.$pgsHelper.cloneObj(datos);
      dataSend.Opciones.forEach((item) => {
        if (!item?.ref?.id) {
          item.ref = null;
        }
      });
      this.$alert.alertConfirm({
        action: "guardar",
        obj: "el modificador",
        route: "PDV-ModificadoresProducto-createModificador",
        data: dataSend,
        onSuccess: () => {
          this.toggleModal(false);
        },
      });
    },
    editModificador(datos) {
      let dataSend = this.$pgsHelper.cloneObj(datos);
      dataSend.Opciones.forEach((item) => {
        if (!item?.ref?.id) {
          item.ref = null;
        }
      });

      this.$alert.alertConfirm({
        action: "editar",
        obj: "el modificador",
        route: "PDV-ModificadoresProducto-updateModificador",
        data: dataSend,
        onSuccess: () => {
          this.toggleModal(false);
        },
      });
    },
    async deleteCategoria(id) {
      let editData = this.$pgsHelper.getById(this.modificadores, "Id", id);
      this.$swal({
        title: "¿Deseas eliminar este modificador?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { Id: id, Departamento: editData.Departamento };
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-ModificadoresProducto-deleteModificador", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Modificador elimando",
              "El modificador se elimino correctamente",
              "success"
            );
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async tetModificadores() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Categorias"
        );

      this.Modificadores = [];
      this.Modificadores = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
  },
  computed: {
    ...mapGetters("dataLists", ["getModificadores"]),
    ...mapGetters("modificadores", ["getModificadoresProducto"]),
    modificadores() {
      let modificadores = this.getModificadores.filter(
        (modi) => modi.Dlat == null
      );
      return modificadores;
    },
  },
  watch: {},
  mounted() {},
  created() {
    //this.getModificadores();
  },
};
</script>
